import styled from 'styled-components'

const ImgEmpty = styled.img<{ margin?: string }>`
  width: 120px;
  height: 120px;
  margin: ${({ margin }) => margin ?? '0'};
`

const Empty: React.FC<{ margin?: string }> = ({ margin }) => {
  return <ImgEmpty src={require('assets/images/prediction/empty.png').default} margin={margin} />
}

export default Empty
